import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/riverpro/h5/');
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppProps {}

const App: React.FunctionComponent<IAppProps> = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('riverproportablepowerstation');

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic name={['RIVERPRO_1.webp', 'RIVERPRO_1.png']} alt={t('river_pro.image.Capacity')} aria-label={t('river_pro.image.Capacity')} />
                        <span className="text">{t('river_pro.image.Capacity')}</span>
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic name={['RIVERPRO_2.webp', 'RIVERPRO_2.png']} alt={t('river_pro.image.600W')} aria-label={t('river_pro.image.600W')} />
                        <span className="text">{t('river_pro.image.AC Output')}</span>
                        <span className="text">{t('river_pro.image.600W')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic name={['RIVERPRO_3.webp', 'RIVERPRO_3.png']} alt={t('river_pro.image.1800W')} aria-label={t('river_pro.image.1800W')} />
                        <span className="text">
                            {t('river_pro.image.X-Boost-pc')} {t('river_pro.image.1800W')}
                        </span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic name={['RIVER_M_04.webp', 'RIVER_M_04.png']} alt={t('river_pro.image.Charging')} aria-label={t('river_pro.image.Charging')} />
                        <span className="text">{t('river_pro.image.X-Stream-pc')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic name={['RIVERPRO_5.webp', 'RIVERPRO_5.png']} alt={t('river_pro.image.devices')} aria-label={t('river_pro.image.devices')} />
                        <span className="text">
                            {t.rich('river_pro.image.devices', {
                                line: (child: React.ReactNode) => (
                                    <>
                                        <br />
                                        <span className="p1">{child}</span>
                                    </>
                                ),
                            })}
                        </span>
                    </div>
                    <div className="view-item view-item-6">
                        <EFPic
                            name={['RIVERPRO_6.webp', 'RIVERPRO_6.png']}
                            alt={t('river_pro.image.App Control')}
                            aria-label={t('river_pro.image.App Control')}
                        />
                        <span className="text">{t.raw('river_pro.image.App Control')}</span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
